import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PhoneComponent } from '@sdvor/shared/ui/v2';

@Component({
  selector: 'sd-no-delivery-message',
  templateUrl: './no-delivery-message.component.html',
  styleUrls: ['./no-delivery-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PhoneComponent],
})
export class NoDeliveryMessageComponent {}
